/*
Author:      Zachary Thomas
Created:     12/30/2021
Modified:    12/30/2021

Copyright 2021 © Cornell Pump Company, All Rights Reserved
-----------------------------------------------------------------
*/

// Change the key name of an object.
export default function changeKeyName(object, oldKey, newKey) {
  if (oldKey in object) {
    object[newKey] = object[oldKey];
    delete object[oldKey];
  }
}